/* eslint-disable max-lines */
import BIC from 'bic';
import FormWatcher from '@/inheritance/form-watcher';
import IBAN from 'iban';
import { required } from 'vuelidate/lib/validators';

const alphanumeric = value => {
    return value.match(/^[a-zA-Z0-9]+$/) !== null;
};

export default {
    name: 'BankAccountDetails',
    // TODO: IS FORMWATCHER NEEDED?
    extends: FormWatcher,
    /**
     * @override
     */
    data() {
        return {
            modifiedBankAccount: {},
            submitted: false
        };
    },
    props: {
        bankAccount: {
            type: Object,
            required: true
        },
        creation: {
            type: Boolean,
            required: false,
            default: false
        },
        edit: {
            type: Boolean,
            required: false,
            default: false
        }

    },
    validations: {
        modifiedBankAccount: {
            iban_code: {
                required,
                /**
                 * Comprueba que el iban sea valido
                 * @param {String} value iban value
                 * @return {Boolean} isValid
                 */
                isValid(value) {
                    return IBAN.isValid(value) && alphanumeric(value);
                }
            },
            swift_code: {
                /**
                 * Comprueba que el BIC/SWIFT sea valido
                 * @param {String} value iban value
                 * @return {Boolean} isValid
                 */
                isValid(value) {
                    return BIC.isValid(value) || !value;
                }
            }
        }
    },
    /**
     * @override
     */
    created() {
        this.modifiedBankAccount = Object.assign({}, this.bankAccount);
    },

    computed: {
        needSwift() {
            if (!this.modifiedBankAccount.iban_code) {
                return false;
            }
            const originOfIbanCode = this.modifiedBankAccount.iban_code ? this.modifiedBankAccount.iban_code.slice(0, 2).toUpperCase() : '';
            return originOfIbanCode !== 'ES';
        },

        isValidIban() {
            const ibanCode = this.modifiedBankAccount.iban_code;
            if (!ibanCode) {
                return false;
            } else {
                return IBAN.isValid(ibanCode) && alphanumeric(ibanCode);
            }
        },

        isValidSwift() {
            const swiftCode = this.modifiedBankAccount.swift_code;
            if (!this.needSwift || !swiftCode) {
                return true;
            } else if (!swiftCode) {
                return false;
            } else {
                return BIC.isValid(swiftCode);
            }
        },

        canSaveBankAccount() {
            const ibanValid = this.modifiedBankAccount.iban_code && this.isValidIban;
            const swiftValid = this.modifiedBankAccount.swift_code && this.isValidSwift;
            if (this.needSwift) {
                return ibanValid && swiftValid;
            } else {
                return ibanValid;
            }
        }
    },

    methods: {
        /**
         * Función genérica para guardar los elementos editados
         * @param {*} field Campo editado
         * @param {*} val Valor
         */
        setValueEdited(field, val) {
            this.modifiedBankAccount[field] = val;
        },
        /**
         * Invierte el valor de editBankAccount
         */
        toggleEdit() {
            this.editBankAccount = !this.editBankAccount;
        },
        /**
         * Emite el evento hideForm
         */
        handleCancel() {
            this.$emit('hideForm', true);
        },
        /**
         * Emite el evento submit
         */
        handleSubmit() {
            this.$v.$touch();
            this.submitted = true;
            if (!this.modifiedBankAccount.swift_code) {
                this.modifiedBankAccount.swift_code = '';
            }
            if (!this.$v.modifiedBankAccount.$invalid) {
                this.$emit('submit', this.modifiedBankAccount);
                this.$emit('hideForm', true);
            }
        }
    }
};
